/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_List_Filter_All_WarehousesInputs */

const vi_product_lot_list_filter_all_warehouses = /** @type {(inputs: Product_Lot_List_Filter_All_WarehousesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả kho`)
};

/**

* @param {Product_Lot_List_Filter_All_WarehousesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_list_filter_all_warehouses = /** @type {((inputs?: Product_Lot_List_Filter_All_WarehousesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_List_Filter_All_WarehousesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_list_filter_all_warehouses(inputs)
});